let locks = 0;
let previousOverflow = '';
export function lockScroll() {
  if (locks === 0) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
  locks += 1;
}
export function unlockScroll() {
  locks = Math.max(0, locks - 1);
  if (locks === 0) document.body.style.overflow = previousOverflow;
}
